import { UrlParams } from 'bluesquare-components';

export const apiBaseUrl = '/api/polio/chronograms';

export const defaultParams: UrlParams = {
    pageSize: '20',
    order: 'id',
    page: '1',
};
